
//親より先に子がロードされる。
//class childView extends keyof  Backbone.View<Backbone.Model>{
//}
//class pareView<TModel extends Backbone.Model> extends Backbone.View<TModel>{
//}


//public abstract class CodeValue<T> : IComparable where T : CodeValue<T>, new()
//abstract class CodeValue<T extends CodeValue<T>>


export abstract class CodeBase<T extends CodeBase<T>>
{
    /** コード値を保持*/
    protected _code: any
    /** コード値を返す*/
    public get code() { return this._code; }
    /** 値を保持*/
    protected _value: any
    /** 値を返す*/
    public get value() { return this._value; }
    /** 略称を返す*/
    protected _abbr: any
    /** 略称を返す*/
    public get abbr() { return this._abbr; }

    /**
     *  ctor
     */
    protected constructor(value: any, text: any, abbr?: any) {
        this._code = value;
        this._value = text;
        this._abbr = abbr;
    }


    /** */
    public toString(): string {

        return this.value;
    }


    //public abstract List(): T[];


    /***/
    public static getAll<T extends CodeBase<T>>(): CodeBase<T>[] {
        let locatedValue = [];
        for (var info in this) {
            if (this[info] instanceof CodeBase) {
                locatedValue.push(this[info]);
            }
        }
        return locatedValue;
    }


    /**
     * 指定しコード値に合致した定義に変換する
     * @param code
     */
    public static toCodeValue<T extends CodeBase<T>>(code: any): CodeBase<T> {
        var all = this.getAll<T>();
        for (var item of all) {
            if (item.equalsCode(code)) {
                return item;
            }
        }
        return null;
    }

    /**
     * 指定した値に合致した定義に変換する
     * @param value
     */
    public static toCodeValueByValue<T extends CodeBase<T>>(value: any): CodeBase<T> {
        var all = this.getAll<T>();
        for (var item of all) {
            if (item.value === value) {
                return item;
            }
        }
        //throw new InvalidCastException("指定した値の列挙値はありません。");
        return null;
    }

    /**
     * 指定した値に合致した定義に変換する
     * @param value
     */
    public static toCodeValueByAbbr<T extends CodeBase<T>>(abbr: any): CodeBase<T> {
        var all = this.getAll<T>();
        for (var item of all) {
            if (item.abbr === abbr) {
                return item;
            }
        }
        //throw new InvalidCastException("指定した値の列挙値はありません。");
        return null;
    }
    /**
     */
    public static getPlaneObjects<T extends CodeBase<T>>(): { code, value, abbr }[] {
        var all = this.getAll<T>();
        var array: { code, value, abbr }[] = [];
        for (var item of all) {
            array.push({
                code: item.code,
                value: item.value,
                abbr: item.abbr || null,
            });
        }
        return array;
    }




    ///**
    // * 指定した文字に合致したValueに変換する
    // * @param text
    // */
    //public static ToValue(text: string) {
    //    var item = CodeValue.ToEmunText(text);
    //    if (item != null) {
    //        return item.Value;
    //    }
    //    //throw new InvalidCastException("指定した値の列挙値はありません。");
    //    return null;
    //}


    ///**
    // * 指定したValueに合致した文字に変換する
    // * @param value
    // */
    //public static ToText(value: any): string {
    //    var item = CodeValue.ToEmun(value);
    //    if (item != null) {
    //        return item.Text;
    //    }
    //    //throw new InvalidCastException("指定した値の列挙値はありません。");
    //    return null;
    //}

    /**
     * 
     * @param obj
     */
    public equals(obj: any): boolean {

        if (!(obj instanceof CodeBase)) { return false; }

        var typeMatches = this === obj;
        var valueMatches = this.code === <T>obj.code;
        return typeMatches && valueMatches;

        //return this === obj;
    }


    /**
     * 
     * @param value
     */
    public equalsCode(value: any): boolean {
        return this.code === value;
    }


    // Other utility methods ...
}
